'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _EventManager = require('./EventManager');

var _EventManager2 = _interopRequireDefault(_EventManager);

var _FrameworkState = require('./FrameworkState');

var _FrameworkState2 = _interopRequireDefault(_FrameworkState);

var _PluginInstaller = require('./PluginInstaller');

var _PluginInstaller2 = _interopRequireDefault(_PluginInstaller);

var _PluginResolver = require('./PluginResolver');

var _PluginResolver2 = _interopRequireDefault(_PluginResolver);

var _PluginStarter = require('./PluginStarter');

var _PluginStarter2 = _interopRequireDefault(_PluginStarter);

var _ServiceManager = require('../service/ServiceManager');

var _ServiceManager2 = _interopRequireDefault(_ServiceManager);

var _ExtensionManager = require('../plugin/ExtensionManager');

var _ExtensionManager2 = _interopRequireDefault(_ExtensionManager);

var _Assert = require('../utility/Assert');

var _Assert2 = _interopRequireDefault(_Assert);

var _log = require('../utility/log');

var _log2 = _interopRequireDefault(_log);

var _Minima = require('../Minima');

var _Minima2 = _interopRequireDefault(_Minima);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 插件框架核心类，组合各个模块实现插件框架启动和停止。暂时不支持直接框架重启，如果要支持重启，则需要对组合的资源进行释放。
 * 
 * @ignore
 * @export
 * @class Framework
 */
var Framework = function () {

    /**
     * 创建一个插件框架实例
     * 
     * @ignore
     * @param {Minima} minima 插件框架外部类
     * @memberof Framework
     */
    function Framework(minima) {
        (0, _classCallCheck3.default)(this, Framework);

        _Assert2.default.notNull('minima', minima);

        this._minima = minima;
        this._startLevel = minima.startLevel;
        this._pluginsDirectories = minima.pluginsDirectories;

        this._state = _FrameworkState2.default.CREATED;

        this._eventManager = new _EventManager2.default();
        this._serviceManager = new _ServiceManager2.default(this);
        this._extensionManager = new _ExtensionManager2.default(this);
        this._pluginInstaller = new _PluginInstaller2.default(this);

        this._pluginResolver;
        this._pluginStarter;

        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.doStop = this.doStop.bind(this);
    }

    /**
     * 插件框架目前的状态
     * 
     * @type {FrameworkState}
     * @memberof Framework
     */


    (0, _createClass3.default)(Framework, [{
        key: 'start',


        /**
         * 启动插件框架
         * 
         * @memberof Framework
         */
        value: function start() {
            this._pluginInstaller.installPlugins();
            var pluginConfigurations = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(this._pluginInstaller.plugins), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var pair = _step.value;

                    var plugin = pair[1];
                    pluginConfigurations.push(plugin.pluginConfiguration);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this._pluginResolver = new _PluginResolver2.default(pluginConfigurations);
            this._pluginResolver.resolve();

            this._pluginStarter = new _PluginStarter2.default(this, this._pluginInstaller.plugins);
            this._pluginStarter.startPlugins();

            this.state = _FrameworkState2.default.STARTED;
        }

        /**
         * 停止插件框架
         * 
         * @memberof Framework
         */

    }, {
        key: 'stop',
        value: function stop() {
            if (this.state !== _FrameworkState2.default.STARTED) {
                return;
            }

            this.state = _FrameworkState2.default.STOPPING;
            try {
                this.doStop();
            } catch (error) {
                _log2.default.logger.error('Failed to stop the framework since the error ' + error.message + '.', error);
            } finally {
                this.state = _FrameworkState2.default.STOPPED;
            }
        }

        /**
         * 停止插件框架，清理资源
         * 
         * @memberof Framework
         */

    }, {
        key: 'doStop',
        value: function doStop() {
            this._pluginStarter.stopPlugins();

            this._eventManager.dispose();
            this._extensionManager.dispose();
            this._serviceManager.dispose();
            this._pluginStarter.dispose();
            this._pluginResolver.dispose();
            this._pluginInstaller.dispose();
        }
    }, {
        key: 'state',
        get: function get() {
            return this._state;
        }

        /**
         * 更改插件框架状态，仅内部使用
         * 
         * @type {FrameworkState}
         * @memberof Framework
         */
        ,
        set: function set(state) {
            var previous = this._state;
            this._state = state;
            this._eventManager.fireFrameworkStateChanged(this, previous, state);
        }

        /**
         * 插件集合的目录
         * 
         * @type {string[]}
         * @readonly
         * @memberof Framework
         */

    }, {
        key: 'pluginsDirectories',
        get: function get() {
            return this._pluginsDirectories;
        }

        /**
         * 事件管理器
         * 
         * @type {EventManager}
         * @readonly
         * @memberof Framework
         */

    }, {
        key: 'eventManager',
        get: function get() {
            return this._eventManager;
        }

        /**
         * 服务管理器
         * 
         * @type {ServiceManager}
         * @readonly
         * @memberof Framework
         */

    }, {
        key: 'serviceManager',
        get: function get() {
            return this._serviceManager;
        }

        /**
         * 扩展点管理器
         * 
         * @type {ExtensionManager}
         * @readonly
         * @memberof Framework
         */

    }, {
        key: 'extensionManager',
        get: function get() {
            return this._extensionManager;
        }

        /**
         * 插件安装器
         * 
         * @type {PluginInstaller}
         * @readonly
         * @memberof Framework
         */

    }, {
        key: 'pluginInstaller',
        get: function get() {
            return this._pluginInstaller;
        }

        /**
         * 插件解析器
         * 
         * @type {PluginResolver}
         * @readonly
         * @memberof Framework
         */

    }, {
        key: 'pluginResolver',
        get: function get() {
            return this._pluginResolver;
        }

        /**
         * 插件框架启动级别
         * 
         * @type {number}
         * @readonly
         * @memberof Framework
         */

    }, {
        key: 'startLevel',
        get: function get() {
            return this._startLevel;
        }
    }]);
    return Framework;
}();

exports.default = Framework;
//# sourceMappingURL=Framework.js.map